import { type QueryHookOptions, useQuery } from "@apollo/client";
import { OrganizationUsersListQuery } from "../graphql/queries";
import type {
  OrganizationUsersListQueryType,
  OrganizationUsersListQueryVariablesType,
} from "@/types/graphql/partner.generated";

export const useOrganizationUsersQuery = (
  options?: QueryHookOptions<
    OrganizationUsersListQueryType,
    OrganizationUsersListQueryVariablesType
  >
) => {
  return useQuery<
    OrganizationUsersListQueryType,
    OrganizationUsersListQueryVariablesType
  >(OrganizationUsersListQuery, options);
};
